module.exports = __webpack_public_path__ + "img/nivel_luz_blue.45eedec6.svg";